import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhTabsetComponent } from './ph-tabset.component';
import { PhTabComponent } from './components/ph-tab/ph-tab.component';

@NgModule({
  declarations: [PhTabsetComponent, PhTabComponent],
  exports: [PhTabsetComponent, PhTabComponent],
  imports: [CommonModule],
})
export class PhTabsetModule {}
